import { registerBlockType } from '@wordpress/blocks';
import Edit from './Edit'
import { InnerBlocks } from "@wordpress/block-editor";

registerBlockType( 'level131/tab', {
    edit: Edit,
    save(props){
        return (
            <InnerBlocks.Content />
        )
    }
} );
